// extracted by mini-css-extract-plugin
export default {"toaster":"style_toaster__8h6wT","toasterHeader":"style_toasterHeader__udDsF","toasterHeaderArabic":"style_toasterHeaderArabic__ayR8H"};